import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "hint", "details"];

  connect() {
    this.sync();
  }

  sync() {
    const on = this.toggleTarget.checked;
    this.hintTarget.classList.toggle("hidden", on);
    this.detailsTarget.classList.toggle("hidden", !on);
  }
}
